import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import RecipientForm from './recipientForm'
import { Recipient } from '../../../models/Recipient'
import Layout from '../../common/layout/layout'
import { createRecipient } from '../../../services/migrantService'
import { toast } from 'react-toastify'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import { useHistory } from 'react-router'
import constants from '../../../config/constants'

const AddRecipient: React.FC = () => {
  const history = useHistory()
  const [isProcessing, setIsProcessing] = useState(false)

  const processRecipient = async (recipientDetail: Recipient) => {
    try {
      setIsProcessing(true)
      await createRecipient(recipientDetail)
      toast.success(constants.alertMessage.docAdded.replace('%s', 'Recipient'))
      setIsProcessing(false)
      history.goBack()
    } catch (err) {
      console.error('createRecipient error:', err)
      toast.error(friendlyMessageFor(err), { autoClose: false })
      setIsProcessing(false)
    }
  }

  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto" data-testid="addRecipientFC">
          <Row>
            <Col>
              <h1 className="pageTitle" data-testid="pageTitle">
                Add Recipient
              </h1>
            </Col>
          </Row>
          <hr />
          <RecipientForm
            isSelf={false}
            submitButtonText="Add recipient"
            onSubmit={processRecipient}
            isProcessing={isProcessing}
          />
        </Col>
      </Row>
    </Layout>
  )
}

export default AddRecipient
